export default "__VITE_ASSET__6f0af3ed__"